// extracted by mini-css-extract-plugin
export default {"loadingText":"LoadingText_loadingText__82n1u","dotOne":"LoadingText_dotOne__bOQEf","dotTwo":"LoadingText_dotTwo__UCcUx","dotThree":"LoadingText_dotThree__7guZ3"};